import { render, staticRenderFns } from "./NIMProjectManager.vue?vue&type=template&id=6bf76e66&scoped=true&"
import script from "./NIMProjectManager.vue?vue&type=script&lang=js&"
export * from "./NIMProjectManager.vue?vue&type=script&lang=js&"
import style0 from "./NIMProjectManager.vue?vue&type=style&index=0&id=6bf76e66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf76e66",
  null
  
)

export default component.exports